<script lang="ts">
  export let variant: 'error' | 'info' | 'success' = 'info';
</script>

<div class="notice notice--{variant}" role={variant === 'error' ? 'alert' : 'status'}>
  <slot />
</div>

<style>
  .notice {
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-md);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-normal);
    border: var(--border-subtle);
    background: var(--color-surface-850);
    color: var(--color-text-secondary);
  }

  .notice--error {
    border-color: rgba(255, 107, 107, 0.35);
    background: rgba(255, 107, 107, 0.08);
    color: var(--color-danger-500);
  }

  .notice--success {
    border-color: rgba(123, 228, 149, 0.35);
    background: rgba(123, 228, 149, 0.08);
    color: var(--color-success-500);
  }
</style>
